import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  constructor(private http: HttpClient) { }

  public getTariffs() {
    return this.http.get<any>(environment.baseURL + '/tariff')
      .pipe(map(res => res.data));
  }

  public getPriceInUAH(priceInUSD: number) {
    return (priceInUSD * 45).toLocaleString('en-US', { minimumFractionDigits: 2 });
  }
}
